<script>
    export default {
        name: "LookbookHero",
        data() {
            return {
                isAnimated: true,
                text: "<span>Путешествуйте. Создавайте.</span> <span>Делайте открытия.</span> <span>Знакомьтесь с невероятными людьми.</span> <span>В&nbsp;каждой вашей истории XD&nbsp;Design</span> <span>будет рядом.</span>",
            };
        },
        mounted() {
            setTimeout(() => {
                this.isAnimated = false;
            }, 500);
        },
    };
</script>

<template>
    <section class="lookbook-hero" :class="{ 'is-animated': isAnimated }">
        <div class="l-container l-container--lookbook-sm">
            <div class="lookbook-hero__inner">
                <div class="lookbook-hero__image">
                    <picture>
                        <source
                            media="(max-width: 991px)"
                            srcset="/static/xd-design/lookbook/hero--mobile.jpg?v=300822"
                        />
                        <img src="/static/xd-design/lookbook/hero.jpg?v=300822" alt="" />
                    </picture>
                </div>

                <div class="lookbook-hero__text" v-html="text"></div>
            </div>
        </div>
    </section>
</template>

<style lang="scss">
    .lookbook-hero {
        position: relative;
        color: #fff;
        background-color: #000;
        overflow: hidden;
        &.is-animated {
            .lookbook-hero__image {
                opacity: 0;
                transform: translateX(-50%);
                img {
                    transform: translate(0) scale(1);
                }
            }
            .lookbook-hero__text {
                opacity: 0;
                span {
                    opacity: 0;
                    transform: translateX(100%);
                }
            }
        }
    }

    .lookbook-hero__inner {
        @include bp($bp-desktop-sm) {
            display: flex;
            min-height: 420px;
        }
        @include bp($bp-desktop-lg) {
            min-height: 600px;
        }
    }

    .lookbook-hero__image {
        position: relative;
        padding-bottom: 97.22%;
        transition: transform 0.7s cubic-bezier(0, 0, 0.13, 1),
            opacity 0.7s cubic-bezier(0, 0, 0.13, 1);
        img {
            @include center-absolute(0);
            width: 100%;
            transition: transform 0.5s ease-in 0.6s;
        }
        @include bp($bp-desktop-sm) {
            flex-shrink: 0;
            width: 600px;
            padding-bottom: 0;
        }
        @include bp($bp-desktop-lg) {
            width: 870px;
        }
    }

    .lookbook-hero__text {
        padding: 32px 24px 40px;
        font-size: 14px;
        font-weight: 400;
        line-height: 28px;
        transition: transform 0.7s cubic-bezier(0, 0, 0.13, 1) 0.3s,
            opacity 0.7s cubic-bezier(0, 0, 0.13, 1) 0.3s;

        span {
            display: inline-block;
            opacity: 1;
            transform: translateX(0);
            transition: opacity 0.4s cubic-bezier(0, 0, 0.13, 1),
                transform 0.4s cubic-bezier(0, 0, 0.13, 1);
            &:nth-child(1) {
                transition-delay: 0.4s;
            }
            &:nth-child(2) {
                transition-delay: 0.8s;
            }
            &:nth-child(3) {
                transition-delay: 1.2s;
            }
            &:nth-child(4) {
                transition-delay: 1.6s;
            }
            &:nth-child(5) {
                transition-delay: 2s;
            }
        }
        @include bp($bp-desktop-sm) {
            align-self: flex-end;
            max-width: 468px;
            padding: 0 16px 65px 30px;
            font-size: 20px;
            line-height: 30px;
            font-weight: 300;
        }
        @include bp($bp-desktop-lg) {
            padding: 0 16px 115px 80px;
        }
    }
</style>
